var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 5.4035C1.49653 5.68601 1.04133 5.68601 0.737856 5.4035C0.434387 5.12099 0.434387 4.69722 0.737856 4.41471L4.45536 0.953949C4.75883 0.671438 5.21403 0.671438 5.5175 0.953949L9.235 4.41471C9.4626 4.69722 9.4626 5.12099 9.235 5.4035C8.93153 5.68601 8.40046 5.68601 8.09699 5.4035L5.7451 3.14341V14.8676C5.7451 15.2208 5.36576 15.5739 4.98643 15.5739C4.53122 15.5739 4.22775 15.2208 4.22775 14.8676V3.14341L1.8 5.4035Z",
    fill: "#0A83FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8143 4.27344C11.3591 4.27344 11.0557 3.99093 11.0557 3.56716C11.0557 3.21402 11.3591 2.86089 11.8143 2.86089H22.3599C22.8151 2.86089 23.1186 3.21402 23.1186 3.56716C23.1186 3.99093 22.8151 4.27344 22.3599 4.27344H11.8143Z",
    fill: "#0A83FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8143 7.31045C11.3591 7.31045 11.0557 7.02794 11.0557 6.60417C11.0557 6.25103 11.3591 5.89789 11.8143 5.89789H20.0839C20.4632 5.89789 20.8426 6.25103 20.8426 6.60417C20.8426 7.02794 20.4632 7.31045 20.0839 7.31045H11.8143Z",
    fill: "#0A83FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8143 10.3475C11.3591 10.3475 11.0557 10.0649 11.0557 9.64118C11.0557 9.28804 11.3591 8.93491 11.8143 8.93491H17.732C18.1872 8.93491 18.4907 9.28804 18.4907 9.64118C18.4907 10.0649 18.1872 10.3475 17.732 10.3475H11.8143Z",
    fill: "#0A83FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8143 13.3844C11.3591 13.3844 11.0557 13.1019 11.0557 12.6782C11.0557 12.325 11.3591 11.9719 11.8143 11.9719H15.456C15.8353 11.9719 16.2147 12.325 16.2147 12.6782C16.2147 13.1019 15.8353 13.3844 15.456 13.3844H11.8143Z",
    fill: "#0A83FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.c6c87c686fb7ce86d66ce3267891890a.svg";
export { ForwardRef as ReactComponent };